import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt-br'; // Importa o idioma
import localeManager from 'element-ui/lib/locale'; // Biblioteca de localização

// import FuncoesUteis from './plugins/FuncoesUteis'

import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

import VueTheMask from 'vue-the-mask'
import currency from 'v-currency-field';
 
Vue.prototype.$http = Axios;

const token = localStorage.getItem('user-token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

// Aplica a localização globalmente antes de carregar ElementUI
localeManager.use(locale);

// Configurar o idioma do Element UI
Vue.use(ElementUI, { locale }); // Aplica o idioma pt-BR

Vue.use(VueTheMask);
Vue.use(currency);
//Vue.use(FuncoesUteis);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
